/* eslint-disable */

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'sidemenu/menu-items';
import distributorMenuItems from 'sidemenu/menu-items(distributor)';
import superDistributorMenuItems from 'sidemenu/menu-items(superdistributor)';
import EmployeeMenuItems from 'sidemenu/menu-items(employee)';
import MisMenuItems from 'sidemenu/menu-items(mis)';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import relationManagerMenuItems from 'sidemenu/menu-items(relationmanager)';
import zoneHeadMenuItems from 'sidemenu/menu-items(zoneheadDashboard)';
import stateHeadMenuItems from 'sidemenu/menu-items(statehead)';
import middleManagerMenuItems from 'sidemenu/menu-items(middlemanager)';
import managerMenuItems from 'sidemenu/menu-items(manager)';
import cspMenuItems from 'sidemenu/menu-items(csp)';
import sanchalakMenuItems from 'sidemenu/menu-items(sanchalak)';
import superDistributorEmployeeMenuItems from 'sidemenu/menu-items(SuperDistEmployee)';
import NavCollapse from './NavCollapse';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const [menu, setMenu] = useState([]);

    const role = localStorage.getItem('role');
    const type = localStorage.getItem('type');
    const employee = localStorage.getItem('employeeRole');
    const user = useSelector((state) => state);
    const isEmployee = localStorage.getItem('isEmployee');
    let newMerchantMenu = menuItem.items;
    if (isEmployee === 'true') {
        newMerchantMenu = menuItem.items.filter((item) => item.id !== 'merchantEmployee');
    }

    useEffect(() => {
        if (role === 'merchants') {
            setMenu(newMerchantMenu);
            // } else if (role === 'distributor' && !employee) {
        } else if (role === 'superdistributor') {
            setMenu(superDistributorMenuItems.items);
        } else if (role === 'superdistributor_employee') {
            setMenu(superDistributorEmployeeMenuItems.items);
        } else if (role === 'admin') {
            setMenu(MisMenuItems.items);
        } else if (type === 'relationmanager') {
            // Handle relationmanager type based on role
            if (role === 'national_head') {
                setMenu(relationManagerMenuItems.items); // Set the menu for national_head
            } else if (role === 'zone_head') {
                setMenu(zoneHeadMenuItems.items); // Set the menu for zone_head
            } else if (role === 'state_head') {
                setMenu(stateHeadMenuItems.items); // Set the menu for state_head
            } else if (role === 'middle_manager') {
                setMenu(middleManagerMenuItems.items); // Set the menu for state_head
            } else if (role === 'manager') {
                setMenu(managerMenuItems.items); // Set the menu for state_head
            }
        } else if (type === 'csp') {
            // Handle CSP type based on role
            if (role === 'CSP') {
                setMenu(cspMenuItems.items); // Ensure you have 'cspMenuItems' defined
            } else if (role === 'SANCHALAK') {
                setMenu(sanchalakMenuItems.items); // Set the menu for zone_head
            }
        } else if ((role === 'distributor' && employee === 'employee') || employee === 'teamleader' || employee === 'teammanager') {
            setMenu(EmployeeMenuItems.items);
        } else {
            setMenu(distributorMenuItems.items);
        }
    }, []);
    // console.log('is menu arry?', menu);
    const navItems = menu.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={1} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
